import { render, staticRenderFns } from "./AppMain.vue?vue&type=template&id=324591f3&scoped=true&"
import script from "./AppMain.vue?vue&type=script&lang=js&"
export * from "./AppMain.vue?vue&type=script&lang=js&"
import style0 from "./AppMain.vue?vue&type=style&index=0&id=324591f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324591f3",
  null
  
)

component.options.__file = "AppMain.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/AppMain.vue
// module id = null
// module chunks = 